import * as React from 'react';

import * as styles from './styles.css';
import { SectionTitle } from '../../SectionTitle';

export const Title: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles['container']}>
      <SectionTitle>{children}</SectionTitle>
    </div>
  );
};
